import { render, staticRenderFns } from "./ForeignOrgaRegulatoryBody.vue?vue&type=template&id=07596000&"
import script from "./ForeignOrgaRegulatoryBody.vue?vue&type=script&lang=ts&"
export * from "./ForeignOrgaRegulatoryBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports